import React from 'react';
import { DecisionTreeRunWithParentFieldsFragment } from '../../../../generated/core-api/graphql-react-query';

export interface DecisionTreeRunContextProps {
  runId: string;
  run: DecisionTreeRunWithParentFieldsFragment | null;
  start(decisionTreeId: string, parentId?: string, isPreviewRun?: boolean): void;
  resume(runId: string): void;
  pause(): void;
  stop(): void;
  chooseChild(parentId: string, value: string, childId: string): void;
  toggleSequenceValue(value: string): void;
  writeComment(nodeId: string, comment: string): void;
}

export const DecisionTreeRunContext = React.createContext<DecisionTreeRunContextProps | null>(null);

export default function useDecisionTreeRunContext() {
  const context = React.useContext(DecisionTreeRunContext);
  if (!context) {
    throw new Error('useDecisionTreeRunContext must be used within a DecisionTreeRunContextProvider');
  }
  return context;
}
